import React, { useState, useEffect } from 'react';
import './ProfileForm.css';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { FaIndustry, FaLightbulb, FaSave, FaTag, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CompleteProfile = () => {
  const { user } = useAuth0();

  const [formData, setFormData] = useState({
    expertise: '',
    industry: '',
    keywords: '', // Keywords field
  });

  const [isAccordionOpen, setIsAccordionOpen] = useState(false); // Track accordion state

  const handleAccordionToggle = () => {
    setIsAccordionOpen((prevState) => !prevState);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userInformation = {
        sub: user.sub,
        expertise: formData.expertise,
        industry: formData.industry,
        keywords: formData.keywords, // Include keywords in payload
        email: user.email,
        name: user.name,
        id: user._id,
      };
      console.log('Payload being sent:', userInformation); // Add this

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/complete-profile`,
        { userInformation }
      );
      if (response.data) {
        setFormData(response.data); // Update the form with the saved values
        toast.success('User settings updated successfully!');
      }
    } catch (error) {
      console.error('Error submitting profile:', error);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      if (!user) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/user-settings`,
          { params: { sub: user.sub } }
        );
        const fetchedUser = response.data;
        if (fetchedUser) {
          setFormData({
            industry: fetchedUser.industry || '',
            expertise: fetchedUser.expertise || '',
            keywords: fetchedUser.keywords || '', // Fetch existing keywords
          });
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [user]);

  return (
    <div className="bg-white profile-form-container">
      <ToastContainer />
      <h2 className="mb-3">
        Your professional profile used for matching with new PR opportunities.
      </h2>
      <form onSubmit={handleSubmit} className="profile-form">
        <div className="form-group">
          <label className="flex items-center space-x-2" htmlFor="industry">
            <FaIndustry className="mr-2" />
            <span>Industry</span>
          </label>
          <select
            className="mb-3"
            id="industry"
            name="industry"
            value={formData.industry}
            onChange={handleChange}
            required
          >
            <option value="">Select your industry</option>
            <option value="business">Business</option>
            <option value="technology">Technology</option>
            <option value="consumerGeneralInterest">Consumer General Interest</option>
            <option value="education">Education</option>
            <option value="energyPower">Energy & Power</option>
            <option value="entertainment">Entertainment</option>
            <option value="giftbag">Giftbag</option>
            <option value="government">Government</option>
            <option value="healthcare">Healthcare</option>
            <option value="lifestyle">Lifestyle</option>
            <option value="sports">Sports</option>
          </select>
        </div>
        <div className="form-group">
          <label className="flex items-center space-x-2" htmlFor="expertise">
            <FaLightbulb className="mr-2" />
            <span>Areas of Expertise</span>
          </label>
          <textarea
            id="expertise"
            name="expertise"
            value={formData.expertise}
            onChange={handleChange}
            required
          ></textarea>
          <p>
            This is what our AI uses to match you against opportunities. To
            connect you with the best media opportunities, we need a clear
            understanding of your professional background. The more details you
            share, the more precise the match will be.
          </p>
        </div>
        <div className="form-group">
          <div
            className="flex mb-3 items-center justify-between cursor-pointer"
            onClick={handleAccordionToggle}
          >
            <div className="flex items-center space-x-2">
              <FaTag className="mr-2" />
              <span>Keywords</span>
            </div>
            {isAccordionOpen ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          {isAccordionOpen && (
            <div className="mt-2">
              <textarea
                id="keywords"
                name="keywords"
                value={formData.keywords}
                onChange={handleChange}
                placeholder="Enter keywords separated by commas, e.g., AI, blockchain, cybersecurity"
                required
              ></textarea>
              <p>
              You'll get notifications whenever these keywords show up in a query. It's best to begin without them and add only when needed for better targeting."
              </p>
            </div>
          )}
        </div>
        <button
          type="submit"
          className="btn btn-primary flex items-center space-x-2"
        >
          <FaSave className="mr-2" />
          <span>Save Changes</span>
        </button>
      </form>
    </div>
  );
};

export default CompleteProfile;
